import { render, staticRenderFns } from "./SettingsLegal.vue?vue&type=template&id=d6fb72f0&scoped=true"
import script from "./SettingsLegal.vue?vue&type=script&lang=js"
export * from "./SettingsLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fb72f0",
  null
  
)

export default component.exports